// Minimal fetch client that adds the ID token AND the Business-plane active tenant.
// The tenant header comes from the ONE canonical selection (lib/tenantSession); without it every
// tenant-sensitive route that has no path tenant fails closed with 409 for a multi-membership caller.
import { tenantHeaders } from './tenantSession';

let tokenProvider = null;
export function setTokenProvider(fn) { tokenProvider = fn; }
export async function apiGet(path) {
  const base = process.env.REACT_APP_API_BASE;
  const headers = { 'Content-Type': 'application/json', ...tenantHeaders() };
  if (tokenProvider) {
    const t = await tokenProvider();
    if (t) headers['Authorization'] = `Bearer ${t}`;
  }
  const res = await fetch(`${base}${path}`, { method: 'GET', headers });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}

export async function apiPost(path, body) {
  const base = process.env.REACT_APP_API_BASE;
  const headers = { 'Content-Type': 'application/json', ...tenantHeaders() };
  if (tokenProvider) {
    const t = await tokenProvider();
    if (t) headers['Authorization'] = `Bearer ${t}`;
  }
  const res = await fetch(`${base}${path}`, {
    method: 'POST', headers, body: JSON.stringify(body || {}),
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}
